import { useEffect } from 'react';
import { AudioWaveform } from '@/components/AudioWaveform';
import { trackLead } from '@/lib/metaPixel';

export default function Waitlist() {
  useEffect(() => {
    trackLead();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden" style={{ backgroundColor: '#050505' }}>
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse 80% 50% at 50% 0%, rgba(255, 255, 255, 0.03) 0%, transparent 50%)'
        }}
      />
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse 60% 40% at 50% 100%, rgba(255, 255, 255, 0.02) 0%, transparent 50%)'
        }}
      />
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse 50% 30% at 50% 40%, rgba(255, 255, 255, 0.05) 0%, transparent 70%)'
        }}
      />
      
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
        <div className="space-y-4">
          <div 
            className="animate-fade-in"
            style={{ animationDelay: '0.05s', animationFillMode: 'both' }}
          >
            <AudioWaveform />
          </div>
          
          <h1 
            className="text-2xl md:text-5xl lg:text-6xl font-bold tracking-tight animate-fade-in whitespace-nowrap"
            style={{ animationDelay: '0.1s', animationFillMode: 'both' }}
          >
            <span className="hero-shimmer">
              DK Music Business Academy
            </span>
          </h1>
          
          <p 
            className="text-base md:text-2xl text-white/50 font-light tracking-wide animate-fade-in"
            style={{ animationDelay: '0.3s', animationFillMode: 'both' }}
          >
            You're on the waitlist. We'll be in touch soon.
          </p>
        </div>
      </div>
    </div>
  );
}
